import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { isEmail, isRequired } from '@luminate/luminate-ts-sdk';
import { ValidatedInput } from './ValidatedInput';
export const EmailInput = forwardRef((props, ref) => {
    return (_jsx(ValidatedInput, { ref: ref, rules: props.rules || [isEmail, isRequired], autoCorrect: props.autoCorrect || false, autoCapitalize: props.autoCapitalize || 'none', keyboardType: 'email-address', ...props }));
});
